import { ReactNode } from 'react'
import { Select } from 'antd'
import { SelectProps } from 'antd/lib/select'
import { Field, FieldProps } from 'formik'

type FilterSelectProps = {
  name: string
  placeholder: string
  children: ReactNode
} & SelectProps<string>

export const ForecastModalFilterSelect = ({ name, placeholder, children, ...restProps }: FilterSelectProps): JSX.Element => {
  return (
    <Field name={name}>
      {({ field: { value, name }, form: { setFieldValue } }: FieldProps) => {
        return (
          <Select
            onChange={(value: string) => {
              setFieldValue(name, value)
            }}
            value={value || undefined}
            placeholder={placeholder}
            {...restProps}
          >
            {children}
          </Select>
        )
      }}
    </Field>
  )
}
